module.exports = __webpack_public_path__ + "static/img/common.efe18bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common.jpg
// module id = rmoQ
// module chunks = 1